import { format } from 'date-fns';

import type { Nullable, Optional } from '@zen/utils/typescript';

import type { Time } from '../types';
import { isParseableAsTime, parseTime } from './parsing';

export const formatTime = (input: Time | string, withSeconds = true): Nullable<string> => {
  if (!isParseableAsTime(input)) return null;

  return format(parseTime(input), withSeconds ? 'HH:mm:ss' : 'HH:mm');
};

export const formatTimeRange = (
  startTime: Time | string,
  endTime: Optional<Time | string> = undefined,
  withSeconds = true
): Nullable<string> => {
  const formattedStartTime = formatTime(startTime, withSeconds);
  const formattedEndTime = formatTime(endTime || '', withSeconds);

  if (!formattedStartTime) return null;

  if (!formattedEndTime || formattedStartTime === formattedEndTime) return formattedStartTime;

  return `${formattedStartTime} - ${formattedEndTime}`;
};
